module.exports = __webpack_public_path__ + "static/media/himatif_itdel_logo.de2e2fe2.png";